jQuery(document).ready(function ($) {
  // Variant selection logic
  $(".webcast-variant").click(function (e) {
    e.preventDefault();

    if (!$(this).hasClass("crossed")) {
      // Deselect all other variants
      $(this)
        .parent(".webcast-quick-variant-wrapper")
        .find(".webcast-variant")
        .removeClass("selected");

      // Select the clicked variant
      $(this).addClass("selected");

      // Get the current variant ID
      var current_var_id = $(this).attr("data-variant-id");
      console.log("Selected variant ID:", current_var_id); // Debugging line

      // Set the variant ID on the add-to-cart button
      $(this)
        .parents(".webcast-variant-box")
        .find(".webcast-atc")
        .attr("data-variant-id", current_var_id);
    }
  });

  // Add to Cart button click logic
  $(".webcast-atc").click(function (e) {
    e.preventDefault();

    var this_btn = $(this);
    var var_id = this_btn.attr("data-variant-id");

    // Check if a variant has been selected
    if (!var_id) {
      alert("Please select a variant before adding to cart.");
      return;
    }

    console.log("Adding variant ID to cart:", var_id); // Debugging line
    this_btn.addClass("btn--loading");

    // Data to be sent in the request
    var addData = {
      id: var_id,
      quantity: 1,
    };

    // Fetch request to add the product to the cart
    fetch("/cart/add.js", {
      body: JSON.stringify(addData),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "xmlhttprequest",
      },
      method: "POST",
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then(function (data) {
        var product = data;
        setTimeout(function () {
          // Dispatch custom event for product added to cart
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:added", {
              detail: {
                product: product,
                addToCartBtn: this_btn,
              },
            })
          );
          this_btn.removeClass("btn--loading");
        }, 1200);
      })
      .catch(function (err) {
        console.error("Error adding to cart:", err); // Improved error handling
        alert("Something went wrong! Please try again later.");
        this_btn.removeClass("btn--loading"); // Ensure the loading class is removed on error
      });
  });

  // Free shipping logic (assuming it's relevant to your cart page)
  if (freethreshold_amount && $("body").hasClass("template-cart")) {
    document.addEventListener("cart:updated", function (evt) {
      var cart = evt.detail.cart;
      console.log("Cart updated:", cart); // Debugging line
      if (cart.item_count == 0) {
        $(".message_cart_shiping").addClass("visually-hidden");
        $(".congrats_msg").addClass("visually-hidden");
        $(".remain_msg").addClass("visually-hidden");
      } else {
        if (cart.total_price >= freethreshold_amount) {
          $(".congrats_msg").removeClass("visually-hidden");
          $(".remain_msg").addClass("visually-hidden");
          $(".message_cart_shiping").find(".item").css("width", "100%");
        } else {
          $(".remain_msg").removeClass("visually-hidden");
          $(".congrats_msg").addClass("visually-hidden");
          var remaining_amount = parseInt(
            freethreshold_amount - cart.total_price
          );
          $(".remain_msg_money").text(
            theme.Currency.formatMoney(
              remaining_amount,
              theme.settings.moneyFormat
            )
          );
          var remaining_amount_percentage = parseFloat(
            (parseInt(freethreshold_amount - remaining_amount) * 100) /
              freethreshold_amount
          );
          $(".message_cart_shiping")
            .find(".item")
            .css("width", remaining_amount_percentage + "%");
        }
      }
    });
  }
});
